// import Vue from "vue";
// const EventBus = new Vue();

import mitt from 'mitt';
const EventBus = mitt();
export default EventBus;
